module.exports = __webpack_public_path__ + "media/images/favicon-8e4f3b836210dfdedf29c00986baa68d.ico";